import React from "react";
import GhostBar from "./GhostBar";

const GhostChart = ({ height = 200 }) => {
  const width = 600;
  const padding = { top: 20, right: 30, bottom: 40, left: 55 };

  // Hardcoded wave path scaled relative to viewbox dimensions
  const ghostPath =
    "M 55 140 L 110 120 L 165 150 L 220 80 L 275 110 L 330 60 L 385 90 L 440 40 L 495 70 L 550 50";
  const areaPath = `${ghostPath} L 550 160 L 55 160 Z`;

  return (
    <div
      className="streamline-wrapper"
      style={{ width: "100%", padding: "10px" }}
    >
      {/* 1. Header Mirror */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          width: "100%",
        }}
      >
        <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
          <GhostBar width="100px" height="12px" />
          <GhostBar width="140px" height="24px" />
        </div>
        <GhostBar width="80px" height="35px" style={{ borderRadius: "6px" }} />
      </div>

      {/* 2. SVG Mirror (Dynamic Height) */}
      <div
        style={{ width: "100%", height: `${height}px`, position: "relative" }}
      >
        <svg
          width="100%"
          height="100%"
          viewBox={`0 0 ${width} ${height}`}
          preserveAspectRatio="none"
          style={{ overflow: "visible" }}
        >
          <defs>
            <linearGradient id="ghostGradient" x1="0" x2="0" y1="0" y2="1">
              <stop offset="0%" stopColor="#E5E7EB" stopOpacity="0.4" />
              <stop offset="100%" stopColor="#E5E7EB" stopOpacity="0" />
            </linearGradient>
          </defs>

          {/* Grid Lines Mirror */}
          {[0, 0.25, 0.5, 0.75, 1].map((p, i) => (
            <line
              key={i}
              x1={padding.left}
              x2={width - padding.right}
              y1={padding.top + (height - padding.top - padding.bottom) * p}
              y2={padding.top + (height - padding.top - padding.bottom) * p}
              stroke="#F3F4F6"
              strokeWidth="1"
            />
          ))}

          {/* Pulsing Area Fill */}
          <path
            d={areaPath}
            fill="url(#ghostGradient)"
            className="skeleton-v2-pulse"
            style={{ animationDuration: "2s" }}
          />

          {/* Pulsing Line */}
          <path
            d={ghostPath}
            fill="none"
            stroke="#E5E7EB"
            strokeWidth="2.5"
            className="skeleton-v2-pulse"
          />
        </svg>
      </div>

      {/* 3. Legend Mirror */}
      <div
        style={{
          display: "flex",
          gap: "15px",
          marginTop: "20px",
          justifyContent: "center",
        }}
      >
        {[1, 2].map((i) => (
          <div
            key={i}
            style={{ display: "flex", alignItems: "center", gap: "6px" }}
          >
            <GhostBar width="10px" height="10px" circle />
            <GhostBar width="50px" height="10px" />
          </div>
        ))}
      </div>
    </div>
  );
};

export default GhostChart;
